export default {
  props: {
    leftFixed: Boolean,
    rightFixed: Boolean
  },
  computed: {
    shouldRenderSelection () {
      return !this.rightFixed && this.selection
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Datatable/src/_mixins/shouldRenderSelection.js